<script>
    import {createEventDispatcher} from "svelte";

    export let title;
    export let dropdownVisible = false;
    export let disabled = false;

    const dispatch = createEventDispatcher();

    function toggleDropdown() {
        dropdownVisible = !dropdownVisible
        dispatch('change', dropdownVisible);
    }

    $: if (disabled && dropdownVisible) {
        toggleDropdown();
    }

    function dismiss() {
        if (dropdownVisible) {
            dropdownVisible = false;
            dispatch('change', dropdownVisible);
        }
    }
</script>

<style>
    .dropdown-outer {
        display: inline;
        position: relative;
    }

    .dropdown-outer .menu-dropdown {
        min-width: 18em;
        text-align: start;
        position: absolute;
        top: 2.5em;
        right: 0;
        padding: 2em;
        background: white;
        border-radius: 3px;
        box-shadow: 0 0 5px black;
        color: black;
        z-index: 1000;
    }

    button.dropdown-btn {
        border: none;
        background: transparent;
        padding: 0;
        display: inline-block;
        color: inherit;
        margin: 0;
    }

    @media (max-width: 650px) {
        .dropdown-outer {
            display: inline-block;
            position: static;
        }

        .dropdown-outer .menu-dropdown {
            left: 0.5em;
            right: 0.5em;
        }
    }
</style>

<svelte:body on:click={dismiss}/>

<div class="dropdown-outer">
    <button {title}
            {disabled}
            class="dropdown-btn"
            on:click|stopPropagation={toggleDropdown}>
        <slot name="icon" {dropdownVisible}></slot>
    </button>

    <!--<i aria-label="Share report"
       on:click={toggleDropdown}
       class="icon icon-link"
       class:active={dropdownVisible}
       role="button"
       tabindex="0"
       data-action="showShareLink"
       title="Share report"></i>-->
    {#if dropdownVisible}
        <div class="menu-dropdown" on:click|stopPropagation={() => {}}>
            <slot name="dropdownContent"></slot>
        </div>
    {/if}
</div>
